// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { CustomProductCarouselCardFragmentDoc } from './carousel/card/CustomProductCarouselCard.fragment.generated';
export const ComponentCustomProductCarouselFragmentDoc = gql`
    fragment componentCustomProductCarousel on ComponentCustomProductCarousel {
  products {
    ...customProductCarouselCard
  }
}
    ${CustomProductCarouselCardFragmentDoc}`;